import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import {getToken, setToken, getRole, getMenu} from '@/utils/auth' // 验权
import { config } from 'shelljs'

const whiteList = ['/login', '/authredirect', '/empty', '/infoManege/empty','/sMap','/jqMap','/outboundmap']// 不重定向白名单

function hasPermission(uri) {
  if (uri === '/index') {
    return true
  }
  let str = uri.split('/')
  let s = str[str.length - 1]
  if (getMenu().indexOf(s) >= 0) return true
  return false
}

console.log(router)
router.beforeEach((to, from, next) => {
  NProgress.start() // 开启Progress
  if (getToken()) { // 判断是否有token
    if (to.path === '/login') {
      next({path: '/'})
      NProgress.done() // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    } else {
      if (store.getters.role.length === 0) {
        store.dispatch('userPreme').then(() => { // 生成可访问的路由表
          router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
          next({...to}) // hack方法 确保addRoutes已完成
        })
      } else {
        next() //TODO 判断出无效的链接
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      console.log(to.meta.web_title)
      let { web_title } = to.meta
      if(web_title){
        document.title = web_title;
      }
      next()
    } else {
      next('/login') // 否则全部重定向到登录页
      NProgress.done() // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js